import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('cds-table-body')
export class TableBodyElement extends LitElement {
  @property({ type: String, reflect: true })
  role = 'rowgroup';

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cds-table-body': TableBodyElement;
  }
}
